import api from '../api';

// A prefetch older than this is dropped rather than shown as current data.
const PREFETCH_MAX_AGE_MS = 10_000;

// Raw API payload; the saga maps it with convertToDashboardData.
type DashboardResponse = any;

class DashboardService {
    // A request started before the dashboard chunk has loaded (see prefetchDashboardData).
    // Handed to the first getDashboardData() call only, so later visits always fetch fresh data.
    private prefetched: Promise<DashboardResponse> | null = null;
    private prefetchedAt = 0;

    private async fetchDashboardData(): Promise<DashboardResponse> {
        const response = await api.get('/progress/learning-path/dashboard/');
        return response.data;
    }

    prefetchDashboardData(): void {
        if (!this.prefetched) {
            this.prefetched = this.fetchDashboardData();
            this.prefetchedAt = Date.now();
            // Avoid an unhandled rejection if nobody consumes it; the consumer retries below.
            this.prefetched.catch(() => undefined);
        }
    }

    // Arrow property: the saga passes this method unbound to `call`.
    getDashboardData = async (): Promise<DashboardResponse> => {
        const prefetched = this.prefetched;
        this.prefetched = null;
        if (prefetched && Date.now() - this.prefetchedAt < PREFETCH_MAX_AGE_MS) {
            return prefetched.catch(() => this.fetchDashboardData());
        }
        return this.fetchDashboardData();
    };
}

export default new DashboardService();
